((window, document) => {
  const ribbonList = [];

  function initiateTilePricing() {
    const tiles = document.querySelectorAll('.monthly-price');
    tiles.forEach((tile) => {
      const price = parseInt(tile.innerHTML.slice(1), 10);
      const resultTileBody = tile.closest('.result-tile__body');
      if (price < 2 || Number.isNaN(price)) {
        const callUs = document.createElement('div');
        callUs.classList.add(
          'font--bold',
          'text--red',
          'text-align--center',
          'heading--3',
          'padding-top-40',
          'padding-bottom-30',
        );
        callUs.innerHTML =
          "<svg class='icon primary-nav__phone' style='vertical-align: bottom;'><use xlink:href='#primaryNavPhone'></use></svg> Call for price";
        resultTileBody.innerHTML = '';
        resultTileBody.appendChild(callUs);
      }
    });
    const hpTiles = document.querySelectorAll('.monthly-hp-price');
    hpTiles.forEach((tile) => {
      const hpPrice = parseInt(tile.innerHTML.slice(1), 10);
      const hpResultTileBody = tile.closest('.result-tile__body');
      if (hpPrice < 2 || Number.isNaN(hpPrice)) {
        hpResultTileBody.querySelector('.no-hp-price').classList.remove('hide__default');
        hpResultTileBody.querySelector('.hp-price').classList.add('hide__default');
      }
    });
  }

  function initiateRadios() {
    const radios = document.querySelectorAll('input[name^="buyLeaseView-"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const tile = e.target.closest('.grid-tile');
        tile.querySelector('.lease-content').classList.toggle('hide__default');
        tile.querySelector('.buy-content').classList.toggle('hide__default');
        const financeType = e.target.id.includes('buy') ? 'buy' : 'lease';
        const requestQuoteButton = tile.querySelector('.js-request-quote');
        const viewOfferCtas = tile.querySelectorAll('.js-viewoffer');
        const oldHref = requestQuoteButton.getAttribute('href');
        const newHref = `${oldHref.slice(0, oldHref.indexOf('?finType='))}?finType=${financeType}`;
        requestQuoteButton.setAttribute('href', newHref);
        viewOfferCtas.forEach((cta) => {
          cta.classList.remove('dt-lease-viewoffer', 'dt-buy-viewoffer');
          const newClass = `dt-${financeType}-viewoffer`;
          cta.classList.add(newClass);
        });
      });
    });
  }

  function loopRibbons() {
    ribbonList.forEach((ribbons) => {
      // Find the currently visible ribbon
      const visibleIndex = ribbons.findIndex((ribbon) =>
        ribbon.classList.contains('ribbon--visible'),
      );

      if (visibleIndex !== -1) {
        // Hide the current ribbon and show the next one
        ribbons[visibleIndex].classList.remove('ribbon--visible');
        const nextIndex = (visibleIndex + 1) % ribbons.length;
        ribbons[nextIndex].classList.add('ribbon--visible');
      }
    });
  }

  // eslint-disable-next-line no-unused-vars
  function initialiseRibbons() {
    // Get all the tiles with ribbons
    const tileList = document.querySelectorAll('.grid-tile .ribbon-container');

    tileList.forEach((tile) => {
      // Get the ribbon data from the data-ribbons attribute
      const ribbon = JSON.parse(tile.getAttribute('data-ribbons'));

      const ribbons = ribbon?.vehicleRibbonDtl;
      ribbons.forEach((ribbon) => {
        // Create a new span element for each ribbon
        const singleRibbon = document.createElement('span');
        const blockSpan = document.createElement('span');
        const ribbonClasses = [
          'js-dynamic-ribbon',
          'ribbon',
          'ribbon--pill',
          'ribbon--visible',
          ribbon.ribbonClass,
        ];
        singleRibbon.classList.add(...ribbonClasses);
        // Clean the ribbon class to create a readable label
        let cleanedClass = ribbon.ribbonClass.replace(/ribbon--/g, '').replace(/-/g, ' ');
        cleanedClass = cleanedClass
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        // Add the ribbon label override if it exists, otherwise use the cleaned class
        singleRibbon.innerText = ribbon.ribbonLabelOverride
          ? ribbon.ribbonLabelOverride
          : cleanedClass;
        singleRibbon.prepend(blockSpan);
        tile.appendChild(singleRibbon);
      });
    });
    tileList.forEach((tile) => {
      // Get all the ribbons within the tile
      const ribbonsArray = [];
      const ribbons = tile.querySelectorAll('.js-dynamic-ribbon');
      if (ribbons.length > 1) {
        // If there are multiple ribbons, add them to the ribbonsArray
        ribbons.forEach((ribbon) => {
          ribbonsArray.push(ribbon);
        });
        ribbonList.push(ribbonsArray);
      }
    });
    ribbonList.forEach((ribbons) => {
      // Show the first ribbon initially
      ribbons[0].classList.add('ribbon--visible');
    });
    setInterval(loopRibbons, 5000);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initiateTilePricing();
    initiateRadios();
    // -- Ribbons function disabled but left for future development --
    // initialiseRibbons();
  });
})(window, document);
